"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageType = exports.ItEventType = exports.ActionType = exports.ActionStatus = exports.TaskStatus = exports.EventName = exports.ComponentType = void 0;
var ComponentType;
(function (ComponentType) {
    ComponentType[ComponentType["Web"] = 0] = "Web";
    ComponentType[ComponentType["SmartApp"] = 1] = "SmartApp";
    ComponentType[ComponentType["Device"] = 2] = "Device";
    ComponentType[ComponentType["BackgroundProcess"] = 3] = "BackgroundProcess";
    ComponentType[ComponentType["WebService"] = 4] = "WebService";
    ComponentType[ComponentType["Executable"] = 5] = "Executable";
    ComponentType[ComponentType["DynamicLinkLibrary"] = 6] = "DynamicLinkLibrary";
    ComponentType[ComponentType["JobService"] = 7] = "JobService";
    ComponentType[ComponentType["WorkflowComponent"] = 8] = "WorkflowComponent";
    ComponentType[ComponentType["DataStore"] = 9] = "DataStore";
    ComponentType[ComponentType["Other"] = 10] = "Other";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var EventName;
(function (EventName) {
    EventName["PageLoad"] = "PageLoad";
    EventName["DropdownSelected"] = "DropdownSelected";
    EventName["DropdownChange"] = "DropdownChange";
    EventName["PageNavigation"] = "PageNavigation";
    EventName["CheckboxChange"] = "CheckboxChange";
    EventName["ListChange"] = "ListChange";
    EventName["ButtonClick"] = "ButtonClick";
    EventName["TabChange"] = "TabChange";
    EventName["TabNavigation"] = "TabNavigation";
    EventName["PanelOpened"] = "PanelOpened";
    EventName["PanelClosed"] = "PanelClosed";
    EventName["PickerSelected"] = "PickerSelected";
    EventName["PickerDeselected"] = "PickerDeselected";
    EventName["TileAdded"] = "TileAdded";
    EventName["TileClicked"] = "TileClicked";
    EventName["TileDeleted"] = "TileDeleted";
    EventName["TileLoaded"] = "TileLoaded";
    EventName["OnFocus"] = "OnFocus";
    EventName["OnBlur"] = "OnBlur";
    EventName["TextChange"] = "TextChange";
    EventName["Scroll"] = "Scroll";
    EventName["SectionRendering"] = "SectionRendering";
    EventName["BackEndAPICall"] = "BackEndAPICall";
    EventName["Rendering"] = "Rendering";
    EventName["NA"] = "NA";
    EventName["Hover"] = "Hover";
    EventName["LinkClicked"] = "LinkClicked";
})(EventName = exports.EventName || (exports.EventName = {}));
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["Start"] = "Start";
    TaskStatus["Completed"] = "Completed";
    TaskStatus["NA"] = "NA";
})(TaskStatus = exports.TaskStatus || (exports.TaskStatus = {}));
var ActionStatus;
(function (ActionStatus) {
    ActionStatus["Succeeded"] = "Succeeded";
    ActionStatus["Failed"] = "Failed";
    ActionStatus["NA"] = "NA";
})(ActionStatus = exports.ActionStatus || (exports.ActionStatus = {}));
var ActionType;
(function (ActionType) {
    ActionType["User"] = "User";
    ActionType["System"] = "System";
    ActionType["Aware"] = "Aware";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ItEventType;
(function (ItEventType) {
    ItEventType[ItEventType["FeatureUsageEvent"] = 0] = "FeatureUsageEvent";
    ItEventType[ItEventType["BusinessProcessEvent"] = 1] = "BusinessProcessEvent";
    ItEventType[ItEventType["BusinessEventMessageExchange"] = 2] = "BusinessEventMessageExchange";
    ItEventType[ItEventType["BusinessEventEntityUpdate"] = 3] = "BusinessEventEntityUpdate";
    ItEventType[ItEventType["BusinessEventDatabaseRecord"] = 4] = "BusinessEventDatabaseRecord";
    ItEventType[ItEventType["SystemEvent"] = 5] = "SystemEvent";
    ItEventType[ItEventType["Other"] = 6] = "Other";
})(ItEventType = exports.ItEventType || (exports.ItEventType = {}));
var StorageType;
(function (StorageType) {
    StorageType[StorageType["LocalStorage"] = 0] = "LocalStorage";
    StorageType[StorageType["SessionStorage"] = 1] = "SessionStorage";
})(StorageType = exports.StorageType || (exports.StorageType = {}));
//# sourceMappingURL=Enum.js.map